const Variant = ({ children }) => <>{children}</>;
Variant.displayName = 'zoolife.ABTest.Variant';
export default Variant;
